import { createContext } from "react";

export const AppConfigContext = createContext({
    language: "English",
    changeLanguage: () => {},
    acceptedLanguages: [],
    isFirstHomePageLoad: () => {},
    onFirstHomePageLoad: () => {}
});
